import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import { apiPromocionesInstance, authHeaderPromociones } from "../../redux/actions/promociones/promociones";

import { Form, Input, Button, Row, Col, Typography, Space, DatePicker } from "antd";
import { toast } from "../../components/toasts/toastStore";

import "./EventosPage.css";
import "./PaquetesPage.css";

const { Title, Text } = Typography;

export default function CrearPromocionPage() {
  const navigate = useNavigate();
  const { idPromocion } = useParams();
  const isEditing = !!idPromocion;

  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!isEditing) return;
    apiPromocionesInstance.get(`/promociones/${idPromocion}`, { headers: authHeaderPromociones() })
      .then((res) => {
        const p = res.data ?? {};
        form.setFieldsValue({
          nombre: p.nombre,
          rango: [dayjs(p.fecha_inicio), dayjs(p.fecha_fin)],
        });
      })
      .catch(() => toast.error("No se pudo cargar la promocion"));
  }, [idPromocion]);

  const handleSave = async () => {
    let values;
    try {
      values = await form.validateFields();
    } catch {
      return;
    }

    const payload = {
      nombre: values.nombre.trim(),
      fecha_inicio: values.rango[0].format("YYYY-MM-DD"),
      fecha_fin: values.rango[1].format("YYYY-MM-DD"),
    };

    setSaving(true);
    try {
      if (isEditing) {
        await apiPromocionesInstance.patch(`/promociones/${idPromocion}`, payload, { headers: authHeaderPromociones() });
        toast.success("Promocion actualizada correctamente");
      } else {
        await apiPromocionesInstance.post("/promociones", payload, { headers: authHeaderPromociones() });
        toast.success("Promocion creada exitosamente");
      }
      navigate("/app/promociones");
    } catch (err) {
      toast.error(err?.response?.data?.detail || err.message || "Error al guardar");
    } finally {
      setSaving(false);
    }
  };

  return (
    <main className="paq-main">
      <div className="paq-content">
        <section className="cc-page-header-card">
          <Space direction="vertical" size={2}>
            <Title level={2} className="eventos-title" style={{ marginBottom: 0 }}>
              {isEditing ? "Editando promocion" : "Nueva promocion"}
            </Title>
            <Text className="eventos-subtitle">
              {isEditing
                ? "Modifica los datos de la promocion y guarda los cambios."
                : "Completa los datos de la promocion para registrarla en el sistema."}
            </Text>
          </Space>

          <Space>
            <Button className="eventos-btn-clean" onClick={() => navigate("/app/promociones")} disabled={saving}>
              Cancelar
            </Button>
            <Button
              type="primary"
              loading={saving}
              icon={!isEditing ? <i className="fa-solid fa-plus" /> : null}
              onClick={handleSave}
              style={{ backgroundColor: "#f90336", borderColor: "#f90336" }}
            >
              {isEditing ? "Guardar cambios" : "Crear promocion"}
            </Button>
          </Space>
        </section>

        <Form form={form} layout="vertical">
          <div className="cc-section-card">
            <div className="cc-section-header">
              <span className="cc-section-icon"><i className="fa-solid fa-tag"></i></span>
              Datos de la promocion
            </div>

            <Row gutter={16}>
              <Col xs={24}>
                <Form.Item
                  name="nombre"
                  label={<span className="paq-field-label">Nombre de la promocion</span>}
                  rules={[{ required: true, message: "Requerido" }]}
                >
                  <Input placeholder="Ej. Descuento de aniversario" autoComplete="off" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24}>
                <Form.Item
                  name="rango"
                  label={<span className="paq-field-label">Vigencia</span>}
                  rules={[{ required: true, message: "Requerido" }]}
                >
                  <DatePicker.RangePicker style={{ width: "100%" }} format="DD/MM/YYYY" />
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
      </div>
    </main>
  );
}
